module.exports = __webpack_public_path__ + "static/media/meta-social.cef880d4.jpg";